import React from 'react';
import { useHistory } from 'react-router-dom';

import { CSS, Link, Typography } from '@project44/manifest-ds';

type ForgotPasswordLinkType = {
  text?: string;
  linkText: string;
  style?: CSS;
  username: string;
};

const ForgotPasswordLink = ({
  text,
  linkText,
  style,
  username,
}: ForgotPasswordLinkType) => {
  const history = useHistory();

  return (
    <Typography variant="caption" css={style}>
      {text}
      <Link
        css={{
          color: 'inherit',
          fontSize: 'inherit',
          fontWeight: 'inherit',
          lineHeight: 'inherit',
        }}
        onClick={() => {
          history.push('/login/forgot-password', { username });
        }}
      >
        {linkText}
      </Link>
    </Typography>
  );
};

export default ForgotPasswordLink;
